<template>
  <div class="checkout-section-inner">
    <form v-on:submit.prevent="saveDetails">
      <div class="form-group">
        <label for="first-name" class="control-label">First Name</label>
        <input id="first-name" required type="text" v-model="orderDetails.firstName" class="form-control"></input>
      </div>

      <div class="form-group">
        <label for="last-name" class="control-label">Last Name</label>
        <input id="last-name" required type="text" v-model="orderDetails.lastName" class="form-control"></input>
      </div>

      <div class="form-group">
        <label for="email" class="control-label">Email</label>
        <input id="email" required type="email" v-model="orderDetails.emailAddress" class="form-control"></input>
      </div>

      <ul>
        <li v-for="error in emailErrors">
          {{error}}
        </li>
      </ul>

      <div class="form-group">
        <label for="mobile" class="control-label">Mobile Contact</label>
        <input id="mobile" required type="number" v-model="orderDetails.mobile" class="form-control"></input>
      </div>

      <button type="submit" id="next" class="btn btn-secondary">
        <i class="fas fa-arrow-circle-right"></i>
        Next
      </button>
    </form>
  </div>
</template>
<script>
import { addCustomerDetails } from "../../../shopfront/cartDataService";
export default {
  props: {
    cartPid: { required: true, type: String }
  },
  data() {
    return {
      orderDetails: {},
      errors: []
    }
  },
  computed: {
    emailErrors() {
      return this.errors.filter(function(error) {
        return error.field === "email"
      }).map( error => error.message)
    }
  },
  methods: {
    saveDetails: function() {
      let vm = this
      vm.errors = []
      addCustomerDetails(this.cartPid, vm.$store.state.sellerPid, this.orderDetails, function() {
        vm.$emit('sectionComplete')
      }, function(error) {
        vm.errors.push(error.response.data)
      })
    }
  }
};
</script>
